export const PRE_EXISTING_CONDITIONS = [
  'Diabetes Type 1',
  'Diabetes Type 2',
  'Hypertension',
  'Heart Disease',
  'Asthma',
  'COPD',
  'Depression',
  'Anxiety',
  'Arthritis',
  'Osteoporosis',
  'High Cholesterol',
  'Kidney Disease',
  'Liver Disease',
  'Stroke',
  'Cancer',
  'Thyroid Disorders',
  'Sleep Apnea',
  'Allergies',
  'Migraine',
  'Epilepsy',
  'Chronic Pain',
  'Obesity',
  'Anemia',
  'Gastroesophageal Reflux Disease (GERD)',
  'Inflammatory Bowel Disease (IBD)',
  'Chronic Fatigue Syndrome',
  'Fibromyalgia',
  'Bipolar Disorder',
  'Schizophrenia',
  'Alzheimer\'s Disease',
  'Parkinson\'s Disease',
  'Multiple Sclerosis',
  'HIV/AIDS',
  'Hepatitis B',
  'Hepatitis C',
  'Tuberculosis'
];